import Aircraft from './aircraft';
import AirlineCompany from './airlineCompany';
import Airport from './airport';
import Currency from '../currency';
import Entity from '../entity';
import FlightClass from './flightClass';
import FlightProvider from './flightProvider';
import FlightSaleChannel from './flightSaleChannel';
import FlightSegment from './flightSegment';
import PassengerType from '../passengerType';
export default class FlightPriceGeneral extends Entity<number> {
  flightClass: FlightClass;
  flightSegment: FlightSegment;
  passengerType: PassengerType;
  salesChannel: FlightSaleChannel;
  endUserOwPrice: string;
  endUserRtPrice: string;
  oneWayPrice: string;
  roundTripPrice: string;
  minAge: string;
  maxAge: string;
  quota: string;
  isGroup: boolean;
  isNew: boolean;
  isPropertyAnyChange: boolean;
  flightId: number | string;
  pricePassengerTypeId: [];
}
